module.exports = __webpack_public_path__ + "media/images/pocstock-cant-find-stock-ad-8a56851cd109f01abb4e77aad2ea405a.png";